import Layout from '../../../components/Layout/Auth';
import Content from '../../../components/Pages/Auth/Setup';
import { displayName } from '../../../config';

const SignUp = (): JSX.Element => {
  document.title = `${displayName}: Setup`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default SignUp;
